import React, { useState, useEffect } from 'react';

const defaultCycle = ['flash-red', 'flash-blue', 'flash-pink'];

const FlashingAd = ({ enabled, message, href, caption, colorCycle }) => {
  const [flashState, setIsFlashing] = useState(0);
  const cycle = colorCycle?.length ? colorCycle : defaultCycle;

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const flashInterval = setInterval(() => {
      setIsFlashing((prev) => (prev + 1) % (cycle.length + 1));
    }, 2500);

    return () => clearInterval(flashInterval);
  }, [cycle.length, enabled]);

  const getFlashClass = () => {
    if (flashState === 0) {
      return '';
    }

    return cycle[flashState - 1] || '';
  };

  if (!enabled) {
    return null;
  }

  return (
    <div>
      <div className="ad-container">
        <div className="star"></div>
        <div className="star"></div>
        <div className="star"></div>
        <div className="star"></div>
        <div className="star"></div>
        <div className="star"></div>
        <div className="star"></div>
        <div className="star"></div>
        <div className="star"></div>
        <div className="star"></div>
        <div className="star"></div>
        <div className="star"></div>
        <div className="star"></div>
        <div className="star"></div>
        <div className="star"></div>
        {/* 
        <div className={`flashing-ad ${isFlashing ? 'flash' : ''}`}>
        */
        }
        <div className={`flashing-ad ${getFlashClass()}`}>
          <a href={href}>{message}</a>
        </div>
      </div>
      <span className="ad-caption">{caption}</span>
    </div> 
  );
};

export default FlashingAd;
